var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "f7:exclamationmark-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.5297 18.5376C15.1922 18.5376 19.0675 14.6705 19.0675 9.99977C19.0675 5.33727 15.1836 1.46191 10.5211 1.46191C5.85076 1.46191 1.99219 5.33727 1.99219 9.99977C1.99219 14.6705 5.85897 18.5376 10.5297 18.5376ZM10.53 17.1148C6.57862 17.1148 3.42254 13.9505 3.42254 9.99977C3.42254 6.05691 6.57004 2.88477 10.5211 2.88477C14.4636 2.88477 17.6358 6.05727 17.6443 9.99977C17.6525 13.9508 14.4718 17.1148 10.5293 17.1148M10.5211 11.5148C10.9225 11.5148 11.1486 11.2887 11.1568 10.8537L11.2825 6.43406C11.2911 6.00691 10.9561 5.68906 10.5125 5.68906C10.0604 5.68906 9.74254 5.9987 9.75076 6.42549L9.85969 10.8537C9.8679 11.2805 10.1025 11.5148 10.5211 11.5148ZM10.5211 14.2351C10.9979 14.2351 11.4247 13.8501 11.4247 13.3648C11.4247 12.8708 11.0065 12.4941 10.5211 12.4941C10.0272 12.4941 9.61683 12.8791 9.61683 13.3648C9.61683 13.8419 10.0354 14.2351 10.5211 14.2351Z",
    fill: "#C4C4C4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info_icon.c6802ed19944d2d454b8a1fcfabb4091.svg";
export { ForwardRef as ReactComponent };